'use strict';

var Peer = require('./Peer');
var transports = require('./transports');

module.exports = {
	/**
  * Expose Peer.
  */
	Peer: Peer,

	/**
  * Expose the built-in WebSocketTransport.
  */
	WebSocketTransport: transports.WebSocketTransport
};


//////////////////
// WEBPACK FOOTER
// ./~/protoo-client/lib-es5/index.js
// module id = 688
// module chunks = 0